<template>
    <div>
        <div class="submit_form">
            <div class="elementor-text-editor" v-if="!showContact">
                <div class="callUs">联系我们</div>
                <div style="text-align: center">
                    温馨提示：感谢您对我们服务的关注！有任何问题，请填写下面的表格，立即与我们联系
                </div>
            </div>
            <el-row :gutter="showContact ? 12 : 24">
                <el-col :span="showContact ? 12 : 24">
                    <div class="grid-content bg-purple">
                        <el-form
                            ref="ruleForm"
                            :model="form"
                            :rules="rules"
                            class="ruleForm"
                        >
                            <el-row :gutter="24">
                                <el-col :span="11">
                                    <el-form-item prop="name" class="formName">
                                        <label
                                        ><img src="../assets/img/form_name.png" alt=""
                                        /></label>
                                        <el-input v-model="form.name" placeholder="姓名"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" :offset="2">
                                    <el-form-item class="formEmail" prop="mail">
                                        <label>
                                            <img src="../assets/img/form_email.png" alt=""/>
                                        </label>
                                        <el-input v-model="form.mail" placeholder="邮箱"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :span="11">
                                    <el-form-item prop="telPhone" class="formTel">
                                        <label
                                        ><img src="../assets/img/form_tel.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.telPhone"
                                            placeholder="电话"
                                            maxlength="11"
                                            id="phone"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" :offset="2">
                                    <el-form-item class="formCompany" prop="company">
                                        <label
                                        ><img src="../assets/img/form_Company.png" alt=""
                                        /></label>
                                        <el-input v-model="form.company" placeholder="公司"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item prop="serviceName">
                                        <label
                                        ><img src="../assets/img/form_list.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.serviceName"
                                            placeholder="咨询业务"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item>
                                        <label
                                        ><img src="../assets/img/form_info.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.remark"
                                            placeholder="需求说明"
                                            type="textarea"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div>
                            <span>验证结果：</span>
                            <span>{{ firstNumber }}</span>
                            <span>+</span>
                            <span>{{ lastNumber }}</span>
                            <span>=</span>
                            <input
                                type="text"
                                placeholder="请输入"
                                class="input"
                                v-model="addNum"
                            />
                            <span :style="{ color: code_color }">{{ error_text }}</span>
                        </div>
                        <div style="text-align: center; margin-top: 20px">
                            <button @click="submitForm('ruleForm')">提交信息</button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12" v-if="showContact">
                    <div class="grid-content bg-purple-light">
                        <div>
                            <div class="title">
                                <p>联系我们</p>
                            </div>
                            <div class="submit_form_content">
                                <div>
                                    <svg-icon icon-class="dianhua"/>
                                    <span>电话：010-67869385</span>
                                </div>
                                <div>
                                    <svg-icon icon-class="phone"/>
                                    <span>手机：186-0066-9830</span>
                                </div>
                                <div>
                                    <svg-icon icon-class="wechat"/>
                                    <span>微信：186-0066-9830</span>
                                </div>
                                <div>
                                    <svg-icon icon-class="qq"/>
                                    <span>QQ：2335752465</span>
                                </div>
                                <div>
                                    <svg-icon icon-class="mail"/>
                                    <span>邮箱：info@biotech-pack.com</span>
                                </div>
                                <div>
                                    <svg-icon icon-class="address"/>
                                    <span
                                    >地址：北京市经济技术开发区科创六街88号院</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 移动端结构 -->
        <div class="molidForm">
            <div class="elementor-text-editor" v-if="!showContact">
                <div class="callUs">联系我们</div>
                <div style="text-align: center">
                    温馨提示：感谢您对我们服务的关注！有任何问题，请填写下面的表格，立即与我们联系
                </div>
            </div>
            <el-row :gutter="showContact ? 12 : 24">
                <el-col :span="showContact ? 12 : 24">
                    <div class="grid-content bg-purple">
                        <el-form
                            ref="ruleForm"
                            :model="form"
                            :rules="rules"
                            class="ruleForm"
                        >
                            <el-row :gutter="24">
                                <el-col>
                                    <el-form-item prop="name" class="formName">
                                        <label
                                        ><img src="../assets/img/form_name.png" alt=""
                                        /></label>
                                        <el-input v-model="form.name" placeholder="姓名"/>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item class="formEmail" prop="mail">
                                        <label>
                                            <img src="../assets/img/form_email.png" alt=""/>
                                        </label>
                                        <el-input v-model="form.mail" placeholder="邮箱"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col>
                                    <el-form-item prop="telPhone" class="formTel">
                                        <label
                                        ><img src="../assets/img/form_tel.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.telPhone"
                                            placeholder="电话"
                                            maxlength="11"
                                            id="phone"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item class="formCompany" prop="company">
                                        <label
                                        ><img src="../assets/img/form_Company.png" alt=""
                                        /></label>
                                        <el-input v-model="form.company" placeholder="公司"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item prop="serviceName">
                                        <label
                                        ><img src="../assets/img/form_list.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.serviceName"
                                            placeholder="咨询业务"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item>
                                        <label
                                        ><img src="../assets/img/form_info.png" alt=""
                                        /></label>
                                        <el-input
                                            v-model="form.remark"
                                            placeholder="需求说明"
                                            type="textarea"
                                            style="width: 19rem"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div>
                            <span>验证结果：</span>
                            <span>{{ firstNumber }}</span>
                            <span>+</span>
                            <span>{{ lastNumber }}</span>
                            <span>=</span>
                            <input
                                type="text"
                                placeholder="请输入"
                                class="input"
                                v-model="addNum"
                            />
                            <span :style="{ color: code_color }">{{ error_text }}</span>
                        </div>
                        <div style="text-align: center; margin-top: 20px">
                            <button @click="submitForm('ruleForm')">提交信息</button>
                        </div>
                    </div>
                </el-col>
                <!-- <el-col :span="12" v-if="showContact">
                  <div class="grid-content bg-purple-light">
                    <div>
                      <div class="title">
                        <p>联系我们</p>
                      </div>
                      <div class="submit_form_content">
                        <div>
                          <svg-icon icon-class="dianhua" />
                          <span>电话：010-67869385</span>
                        </div>
                        <div>
                          <svg-icon icon-class="phone" />
                          <span>手机：186-0066-9830</span>
                        </div>
                        <div>
                          <svg-icon icon-class="wechat" />
                          <span>微信：186-0066-9830</span>
                        </div>
                        <div>
                          <svg-icon icon-class="qq" />
                          <span>QQ：2335752465</span>
                        </div>
                        <div>
                          <svg-icon icon-class="mail" />
                          <span>邮箱：info@biotech-pack.com</span>
                        </div>
                        <div>
                          <svg-icon icon-class="address" /><span
                            >地址：北京市经济技术开发区科创六街88号院</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col> -->
            </el-row>
        </div>
    </div>
</template>

<script>
const api = "https://www.pro-omicstech.com/back/api";

const defaultForm = {
    name: "",
    mail: "", // 邮箱
    serviceName: "", // 实验目的
    telPhone: "", // 手机号
    remark: "", // 需求说明
    company: "", // 公司名称
};

export default {
    name: "userInfoSubmit",
    props: {
        // 是否显示联系方式
        showContact: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            form: Object.assign({}, defaultForm),
            rules: {
                name: [{required: true, message: "请输入姓名", trigger: "blur"}],
                // 验证手机号码格式
                telPhone: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur",
                    },
                ],
                // 验证邮箱格式
                mail: [
                    {required: true, message: "请输入邮箱", trigger: "blur"},
                    {
                        pattern:
                            /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: "请输入正确的邮箱",
                        trigger: "blur",
                    },
                ],
                serviceName: [
                    {required: true, message: "请输入实验目的", trigger: "blur"},
                ],
            },
            //随机数
            firstNumber: null, // 第一个随机数
            lastNumber: null, //随机数
            addNum: null, // 输入的数字
            error_text: "", // 错误提示信息
            code_color: "#000", // 错误提示信息颜色
            //判断是否验证通过
            flag: false,
        };
    },
    mounted() {
        this.randomNumber();
    },
    methods: {
        //提交表单
        submitForm(ruleForm) {
            // 判断两随机数相加是否等于输入的数字
            if (
                parseInt(this.firstNumber) + parseInt(this.lastNumber) ===
                parseInt(this.addNum)
            ) {
                this.flag = true;
                this.error_text = "";
            } else {
                this.flag = false;
                this.error_text = "请输入正确的值";
                this.code_color = "red";
                return false;
            }
            this.$refs[ruleForm].validate((valid) => {
                if (valid && this.flag) {
                    this.$axios
                        .post(api + "/official-web-api/post-message", this.form)
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.$message.success({
                                    message: "提交成功",
                                });
                            } else {
                                this.$message.error("提交失敗");
                            }
                        });
                    this.form = Object.assign({}, defaultForm);
                    // 重新生成随机数
                    this.randomNumber();
                } else {
                    return false;
                }
            });
        },
        // 随机数
        randomNumber() {
            this.firstNumber = Math.ceil(Math.random() * 20);
            this.lastNumber = Math.ceil(Math.random() * 10);
        },
    },
};
</script>


<style lang="scss" scoped>
@import "../scss/molidForm.scss";

.submit_form {
    z-index: 9999;
    //overflow-x: auto; /* 当内容超出高度时显示垂直滚动条 */
    //overflow-y: scroll;
    max-width: 1240px;
    //border-top: 1px solid #ff0000;
    padding-top: 30px;
    margin: 0 auto;
    margin-bottom: 60px;
    margin-top: 0px;

    /deep/ .el-form-item__content {
        display: flex;
    }

    .formBox {
        display: flex;
        justify-content: space-between;
    }

    .ruleForm {
        padding-right: 40px;

        img {
            margin-right: 20px;
            margin-top: 10px;
        }
    }

    .input:focus {
        outline: none;
    }

    .title {
        margin-left: 20px;

        p {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
        }

        p:before {
            content: "|";
            display: inline-block;
            color: #142797;
            margin-right: 20px;
        }
    }
}

button {
    background: #142797;
    color: #fff;
    padding: 10px 15px;
    border: none;
}

.submit_form_content {
    div {
        color: #7b7b7b;
        display: inline-block;
        margin: 20px;
    }
}

/deep/ .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 40px;
}

.elementor-text-editor {
    margin-bottom: 30px;

    .callUs {
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userInfoSubmit.vue